module.exports = __webpack_public_path__ + "static/media/Calendar-New.149394a0.svg";